import { takeEvery, put, call } from "redux-saga/effects";

import { RESET_PASSWORD } from "./actionTypes";
import { userResetPasswordSuccess, userResetPasswordError } from "./actions";
import { resetUserPassword } from "../../../helpers/backend.helper";

function* resetPassword({ payload: { request, history } }) {
  try {
    const response = yield call(resetUserPassword, {
      password: request.password,
      passwordConfirm: request.passwordConfirm,
      token: request.token,
    });
    if (response) {
      yield put(userResetPasswordSuccess("Password Reset Success"));
    }
    history.push("/login");
  } catch (error) {
    yield put(userResetPasswordError(error));
  }
}

function* resetPasswordSaga() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

export default resetPasswordSaga;
